import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MssFieldBaseFieldTypeComponent } from '../mss-field-base.component';
import { MSS_FORMLY_IMPORTS } from '../../formly-standalone-imports';

@Component({
  selector: 'lib-ff-input',
  templateUrl: 'input.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ...MSS_FORMLY_IMPORTS,
  ],
})
export class InputFieldTypeComponent extends MssFieldBaseFieldTypeComponent {
  get type() {
    return this.props.type ?? 'text';
  }
}
